import Permissions from '../../app/permissions/Permissions';
import hasRequiredPermissions from './hasRequiredPermissions';


const getRoutesToRender = (computedRoutes, permissions) => {
    const allowedRoutes = [];
    if (computedRoutes && permissions) {
        const routesPermissions = [
            {
                route: computedRoutes.HOME,
                requiredPermissions: permissions
            },
            {
                route: computedRoutes.USERS,
                requiredPermissions: [Permissions.USER_LIST.name]
            },
            {
                route: computedRoutes.MERCHANT_ACCOUNTS,
                requiredPermissions: [Permissions.CONTRACTS_ACCESS_LIST.name]
            },
            {
                route: computedRoutes.SEARCH_CONTRACTS,
                requiredPermissions: [Permissions.MERCHANT_CONTRACT_LIST_FROM_PROVIDER.name]
            },
            {
                route: computedRoutes.SUBSCRIPTIONS,
                requiredPermissions: [Permissions.SUBSCRIPTION_LIST.name]
            },
            {
                route: computedRoutes.REMOTE_COLLECTION,
                requiredPermissions: [Permissions.PAYMENT_LIST_REMOTE_COLLECTIONS.name]
            },
            {
                route: computedRoutes.ORGANIZATIONS,
                requiredPermissions: [Permissions.ORGANIZATION_LIST.name]
            },
            {
                route: computedRoutes.PLANS,
                requiredPermissions: [Permissions.SUBSCRIPTION_PLAN_LIST_CLIENT_PLANS.name]
            },
            {
                route: computedRoutes.PUSH_PAYMENTS,
                requiredPermissions: [Permissions.PUSH_PAYMENT_READ.name]
            },
            {
                route: computedRoutes.SIM_CARDS,
                requiredPermissions: [Permissions.SIM_LIST.name]
            },
            {
                route: computedRoutes.ENVELOPES,
                requiredPermissions: [Permissions.LIST_REMOTE_DOWNLOADS.name]
            },
            {
                route: computedRoutes.HISTORICS,
                requiredPermissions: [Permissions.LIST_HISTORY.name]
            },
            {
                route: computedRoutes.DOCUMENTATION,
                requiredPermissions: permissions
            },
            {
                route: computedRoutes.NEWSLETTER,
                requiredPermissions: permissions
            }
        ];
        routesPermissions.forEach(routePermissions => {
            if (hasRequiredPermissions({
                permissions: permissions,
                requiredPermissions: routePermissions.requiredPermissions
            })) {
                allowedRoutes.push(routePermissions.route);
            }
        });
    }
    return [...new Set(allowedRoutes)];
};

export default getRoutesToRender;